import { BaseSvgIcon } from './BaseSvgIcon'

export const HomeIcon = (props: any) => {
  const { width = 19, height = 19, fill = 'currentColor', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 100 100" fill="none" {...rest}>
      <g clipPath="url(#clip0_402_151)">
        <path
          d="M97.3036 43.4952C97.3013 43.4929 97.299 43.4906 97.2967 43.4883L56.5047 2.69775C54.7659 0.958252 52.4542 0 49.9953 0C47.5363 0 45.2246 0.957489 43.4851 2.69699L2.71437 43.4669C2.70064 43.4807 2.68691 43.4952 2.67318 43.5089C-0.897381 47.1001 -0.891278 52.9266 2.69072 56.5086C4.32723 58.1459 6.48864 59.0942 8.79958 59.1934C8.89342 59.2026 8.98803 59.2072 9.08339 59.2072H10.7092V89.2265C10.7092 95.1668 15.5424 100 21.4842 100H37.4434C39.0608 100 40.3731 98.6885 40.3731 97.0703V73.5352C40.3731 70.8244 42.578 68.6195 45.2887 68.6195H54.7018C57.4126 68.6195 59.6175 70.8244 59.6175 73.5352V97.0703C59.6175 98.6885 60.9289 100 62.5471 100H78.5063C84.4481 100 89.2813 95.1668 89.2813 89.2265V59.2072H90.7889C93.2471 59.2072 95.5588 58.2497 97.299 56.5102C100.885 52.9221 100.886 47.0856 97.3036 43.4952Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_402_151">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}
